import React, { Component } from "react";
import { Container, Header, Icon, Divider, List } from "semantic-ui-react";
import "./home.css";
import moment from "moment";
class ExpectedAbsences extends Component {
  genabsences() {
    if (this.props.absences.length !== 0 && this.props.employees.length !== 0) {
      return this.props.absences.map(absent => {
        var empinfo = null;
        for (let employee of this.props.employees) {
          if (employee.empnumber === absent.empnumber && absent.delete !== 1) {
            empinfo = employee;
          }
        }
        if (empinfo !== null) {
          let outdate = moment(absent.dateout).format("MM/DD/YY");
          let returndate = moment(absent.datereturn).format("MM/DD/YY");
          var icon;
          if (absent.approval === 0) {
            icon = (
              <Icon
                circular
                link
                className="Approval"
                color="red"
                onClick={() => this.props.handleapprove(absent.id)}
                name="warning"
              />
            );
          } else if (absent.approval === 1) {
            icon = (
              <Icon circular className="Approval" color="green" name="check" />
            );
          }

          return (
            <List.Item>
              <List.Content floated="right">
                {absent.empnumber === this.props.myinfo.empnumber ||
                this.props.myinfo.hradmin ? (
                  <Icon
                    circular
                    link
                    className="Approval"
                    onClick={() => {
                      this.props.editabsense(absent);
                    }}
                    name="pencil"
                  />
                ) : (
                  <div />
                )}
                {icon}
              </List.Content>
              <List.Content>
                <List.Header>
                  {empinfo.firstname} {empinfo.lastname}
                </List.Header>
                <List.Description>
                  {this.gendescription(absent)}
                  <div>
                    <b>Out:</b> {outdate} <b>Return:</b> {returndate}
                  </div>
                </List.Description>
              </List.Content>
            </List.Item>
          );
        }
      });
    }
  }
  gendescription(absent) {
    if (absent.comments) {
      return <div>{absent.comments}</div>;
    }
  }
  render() {
    return (
      <Container>
        <div id="absences">
          <Header as="h3" icon="plus" floated="left">
            Expected Absences
          </Header>
          <Header
            as="h3"
            id="absences"
            icon="plus"
            floated="right"
            onClick={() => this.props.showabsence()}
          />
        </div>

        <Divider />
        <List divided vertical-align="middle">
          {this.genabsences()}
        </List>
      </Container>
    );
  }
}
export default ExpectedAbsences;



// WEBPACK FOOTER //
// ./src/components/home-components/absences.js